import React, {useEffect, useRef, useState} from "react";
import ObserversService from "../../../../core/services/observers";
import {createUUId} from "../../../../core/services/utils/utils";
import LazyImage from "../lazy-image";
import {bannerWidthToHeightRatio} from "../../../../core/constants/enums";
import classnames from "classnames";

const Banner = ({
                    widthToHeightAspectRatio = bannerWidthToHeightRatio,
                    url,
                    initialHeight = 200,
                    className,
                    withShadow = false,
                }) => {
    const id = useRef(createUUId(true));
    const [bannerHeight, setBannerHeight] = useState(initialHeight);

    /**
     * As soon as the component mounts:
     * - attaches a resize observer to change the height of the banner with respect to the available width so that
     * the aspect ratio of the banner gets preserved.
     */
    useEffect(() => {
        /**
         * Calculates the height of the banner image based on the image of the
         */
        const calculateHeight = () => {
            const bannerEl = document.getElementById(id.current);
            setBannerHeight(bannerEl.getBoundingClientRect().width / widthToHeightAspectRatio);
        }
        const observer = ObserversService.newResizeObserver(calculateHeight);
        ObserversService.observeResizeObserver(observer, document.getElementById(id?.current));
        calculateHeight();
        return () => {
            ObserversService.disconnectResizeObserver(observer);
        }
    }, [url, widthToHeightAspectRatio])

    return (
        <>
            <div id={id.current} className={classnames('banner', className, {'with-shadow': withShadow})}>
                <div className={'image'}>
                    <LazyImage
                        src={url ?? ''}
                        alt={'banner'}
                        height={bannerHeight}
                    />
                </div>
            </div>
        </>
    );
}

export default Banner;
